import { Space, Checkbox, Popover } from 'antd';

import styles from './map.module.sass';

export default function ControlPanel({ setStatesLayer, setHeatLayer }: any) {
  function handleStateChange(e: any) {
    if (e.target.checked) {
      setStatesLayer(true);
    } else {
      setStatesLayer(false);
    }
  }

  function handleHeatChange(e) {
    if (e.target.checked) {
      setHeatLayer(true);
    } else {
      setHeatLayer(false);
    }
  }

  return (
    <Popover
      content={
        <Space direction="vertical">
          <Checkbox defaultChecked onChange={handleStateChange}>
            States
          </Checkbox>
          <Checkbox>Zip Codes</Checkbox>
          <Checkbox onChange={handleHeatChange}>Heat Map</Checkbox>
        </Space>
      }
    >
      <div className={styles['control-panel']}>Choose Layers</div>
    </Popover>
  );
}
